import { render, staticRenderFns } from "./CourseIntroduction.vue?vue&type=template&id=f20b367e&scoped=true&"
import script from "./CourseIntroduction.vue?vue&type=script&lang=js&"
export * from "./CourseIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./CourseIntroduction.vue?vue&type=style&index=0&id=f20b367e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20b367e",
  null
  
)

export default component.exports